import React from 'react';
import SowStatusSection from './SowStatusSection';

/**
 * @typedef {object} SowStatusSectionWrapperProps
 * @property {Object} eventFormData
 * @property {Array<*>} organizations
 * @property {Object} [validationErrors]
 * @property {(eventFormData: Object | ((prev: Object) => Object)) => void} setEventFormData
 * @property {Array<*>} [availableAtlList]
 * @property {boolean} [loading]
 */

/**
 * @param {SowStatusSectionWrapperProps} props
 */
const SowStatusSectionWrapper = props => {
  const {
    eventFormData,
    organizations,
    validationErrors,
    setEventFormData,
    availableAtlList,
    loading
  } = props;

  const orgUnitNames = getOrgUnitNames(
    organizations.flatMap(org => org.MddapOrgUnits),
    eventFormData.orgUnitIds
  );

  const atlName = getAtlName(availableAtlList, eventFormData.atl);

  const atlObserverName = getAtlName(availableAtlList, eventFormData.atlObserver);

  return (
    <SowStatusSection
      loading={loading}
      data={eventFormData.sowStatuses}
      atlName={atlName}
      atlObserverName={atlObserverName}
      orgUnitNames={orgUnitNames}
      eventStartDate={eventFormData.startDate}
      setEventFormData={setEventFormData}
      sowStatusesErrors={validationErrors.sowStatuses}
    />
  );
};

const getOrgUnitNames = (orgUnits, selectedOrgUnitIds) =>
  orgUnits.filter(orgUnit => selectedOrgUnitIds.includes(orgUnit.Id)).map(orgUnit => orgUnit.Name);

const getAtlName = (availableAtls, selectedATL) => {
  if (!selectedATL || !availableAtls.length) {
    return null;
  }

  return availableAtls.find(atl => atl.ExternalUserId === selectedATL.value).UserLicense.Name;
};

export default SowStatusSectionWrapper;
